import type { TaskRow } from '../api/tasks';
import { isTaskOverdue } from './formatTaskDate';

export const OVERDUE_FILTER_LABEL = 'Overdue';

/** OR semantics within the status filter: any selected value can match. */
export function taskMatchesStatusFilter(task: TaskRow, selected: string[]): boolean {
  if (selected.length === 0) return true;
  return selected.some((sel) => {
    if (sel === OVERDUE_FILTER_LABEL) return isTaskOverdue(task);
    return task.status === sel;
  });
}

/** Ensures the status filter always offers Overdue alongside workflow values from data. */
export function mergeStatusFilterOptions(workflowStatuses: string[]): string[] {
  return Array.from(new Set([...workflowStatuses, OVERDUE_FILTER_LABEL])).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
}
